module.exports = __webpack_public_path__ + "img/primary-edit.9a63d678.svg";